import { render, staticRenderFns } from "./WUserEdit.vue?vue&type=template&id=560e1162&"
import script from "./WUserEdit.vue?vue&type=script&lang=ts&"
export * from "./WUserEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports